import React, { useState, useEffect, useContext } from 'react'
import "./UserProfile.css";
import ProfileSidebar from './ProfileSidebar';
import { fetchClientsAccountsList } from '../../../services/accIqService';
import { COMPANY_LOGO_BASE_URL } from '../../../config/apiConfig';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { Form, Button } from 'react-bootstrap';
import api from '../../../services/api';
import { useUser } from '../../../context/UserContext';
import Alert from '../../HtmlElements/Alert';
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import { AccountListContext } from '../../../context/AccountListContext';
import { getUserStatsObject, setRecordAsFavourite, recordActivity, getUrlDetailsObj } from '../../../services/commonService';

export default function CompanyDetails() {

  useAuth();
  const { user, setMyAllFavourites } = useUser();
  var currentUrl = useLocation().pathname;
  const navigate = useNavigate();
  
  // Current pages are not getting used any more, So navigate
  navigate('/users/view_profile');
  // End: Current pages are not getting used any more, So navigate


  const { accountId, clientName } = useParams();
  const [loader, setLoader] = useState(false);
  const [apiError, setApiError] = useState('');

  const [companies, setCompanies] = useState([]);
  // const [selectedCompanies, setSelectedCompanies] = useState(['honeywell']);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const { allAccounts, toggleFavourite, updateMyReportContext } = useContext(AccountListContext);

  var pageParsedData = getUrlDetailsObj(useLocation, useParams);

  useEffect(() => {
    if(user){
      const userStat = getUserStatsObject("Onboarding", "onboarding_account", "Data: Accounts", currentUrl);
      pageParsedData.page_params = {
        "tab": 'company_profile'
      }
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [user])
  

  const ids = [];
  useEffect(() => {
    const getClientsAccounts = async () => {

      if(user?.client_profile_company_name){

        setCompanies(allAccounts);

        /*
        try {
          // const accounts = await fetchClientsAccountsList(accountId, 'Dell');
          const accounts = await fetchClientsAccountsList(accountId, user?.client_profile_company_name);
          let accounts_list = accounts?.accounts || [];
          accounts_list.map((account, index) => {
            account._id = account.name.toLowerCase().replace(" ", '_');
          });
          
          setCompanies(accounts_list);
        } catch (error) {
          console.error('Error fetching accounts list:', error);
        }
        */
      }
    };
    
    getClientsAccounts();
    
  }, [allAccounts]);
  
  // Toggle selection of a company
  const handleCompanyClick = (companyId) => {
    setSelectedCompanies(prev => 
      prev.includes(companyId) ? prev.filter(id => id !== companyId) : [...prev, companyId]
    );
  };

  const handleCancel = () => {
    const userStat = getUserStatsObject("Onboarding", "cancel", "Data: Accounts", currentUrl);
    recordActivity(userStat);
    if(user?.role_key === "CLIENT_EMPLOYEE"){
      navigate('/user_profile/profile');
    }else{
      navigate('/user_profile/business_segment');
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const favourite_accounts = allAccounts.filter(item => selectedCompanies.includes(item._id));

    setLoader(true);
    try {

      var flg_update = false;
      for (const account of favourite_accounts) {
        const favObj = {
          'record_type': 'account',
          'account_id': account?._id,
          'is_bookmarked' : 1,
          'account_name': account?.name
        }
        flg_update = await setRecordAsFavourite(favObj); 
      }
      if(flg_update){
        await setMyAllFavourites();
        await updateMyReportContext()
        navigate('/dashboard');
      }

    } catch (error) {
      const errorMsg = error.response?.data?.message || 'An error occurred while saving the user.';
      setApiError(errorMsg);
      // console.error('Error saving user:', error);
    }
    setLoader(false);
  }

  return (
    <div className='user_profile_wrapper pt-4 pb-4'>
      {loader === true && (<ScreenLoader />)}
      <div className='container'>
        <div className='user_profile_subblock'>
          {apiError && <Alert type="danger" message={apiError} />}
          <div className='row'>
            <div className='client_head_left'><h5 className="client_head">Client Admin Login</h5>
            </div>

            <div className='col-md-3'>
                <div className='sidebar_profile'>
                  <ProfileSidebar/>
                </div>
            </div>
            <div className='col-md-9'>
              <div className='userprofile_right'>
                <div className='col-md-12'>
                  <Form onSubmit={handleSubmit} name="information" className="user_form_info">
                    <div className="row">
                    {companies.map((company, index) => (
                      <div className="col-md-6" key={index}>
                          <div
                            className='custom-company-tiles'
                            key={company._id}
                            onClick={() => handleCompanyClick(company._id)}
                            style={{
                              backgroundColor: selectedCompanies.includes(company._id) ? '#D0DCE1' : 'white',
                            }}
                          >
                            <img src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(company?.name)}`} alt="image" className="all_account_icon_img" />
                            {company.name}
                          </div>
                      </div>
                    ))}
                    </div>
                    <div className='col-md-12 mt-4'>
                      <div className='prev_next_block'>
                        <Button type='button' onClick={handleCancel} className="previous_btn">
                          Cancel
                        </Button>
                        <Button type='submit' className="next_btn_blue">
                          Submit
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>  
            </div>  
          </div>      
        </div>
      </div>
    </div>
  )
}
